import axiosClient from "../axios";
import { ResultDataModel } from "../../utility/interface/api/result-data";

interface GetFileListReq {
  page_size?: number;
  search_query?: string;
  page_token?: string;
  order_by?: string;
}
interface GetDockerFileListReq {
  command: number;
  new_file_name: string;
  folder?: string;
  new_folder?: string;
  search_keyword: string;
  file: string;
  instance_id: string;
  host_id: string;
  user_id: string;
}

interface DownloadFromDriveReq {
  file_id: string;
  destination_path: string;
}
interface DownloadToDriveReq {
  file_id: string;
  destination_path: string;
  instance_id: string;
  host_id: string;
  user_id: string;
  size?: string;
}

interface DockerToDriveReq {
  source_path: string;
  drive_file_name: string;
  instance_id: string;
  host_id: string;
  user_id: string;
}

export const getFilesListFromGoogleDrive = (
  state: string | null,
  params: GetFileListReq,
) => {
  const url = `drive/files?page_size=${params.page_size}&page_token=${params.page_token}&order_by=folder&search_query=${params.search_query}`;
  const config = {
    headers: {
      state: state || "",
    },
  };
  return axiosClient.get<ResultDataModel<any>>(url, config);
};

export const downloadFromGoogleDrive = (params: DownloadFromDriveReq) => {
  const url = `drive/files/${params.file_id}/content`;
  return axiosClient.get<ResultDataModel<any>>(url, {
    responseType: "blob",
  });
};

export const uploadToGoogleDrive = (params: FormData) => {
  const url = `drive/files`;
  const headers = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };
  return axiosClient.post<ResultDataModel<any>>(url, params, headers);
};

export const downloadDriveToDocker = (params: DownloadToDriveReq) => {
  const url = `instances/${params.instance_id}/file/gdrive/download`;
  return axiosClient.post<ResultDataModel<any>>(url, params);
};

export const uploadDockerToGoogleDrive = (params: DockerToDriveReq) => {
  const url = `instances/${params.instance_id}/file/gdrive/upload`;
  let body = params;
  return axiosClient.post<ResultDataModel<any>>(url, body);
};

// Docker list operation fn

export const getDockerFileList = (params: GetDockerFileListReq) => {
  const url = `instances/${params.instance_id}/fileOps`;
  const body = params;

  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  return axiosClient.post<ResultDataModel<any>>(url, body, config);
};
